module.exports = __webpack_public_path__ + "pc/static/img/paypal.53200236.png";